module.exports = __webpack_public_path__ + "static/travel-tips-add-select-bcad64d09429d5e9308d71cef65917b1.png";